import { useEffect, useCallback } from 'react'

import {
  AppButton,
  AppFlexContainer,
  AppFlexItem,
  AppHeader,
  AppLoader,
  AppMessageBox,
} from 'client/ui-building-blocks'

import { Filter } from 'cat-shared/utils'
import { usePageStateContext, usePage } from 'client/hooks'
import { useGetUser } from 'client/api'

type Props = {
  userId: string
  categoryId: string
}

export const RandomizerSummary = ({ userId, categoryId }: Props) => {
  const { setBrowseQuestionsPageState } = usePageStateContext()
  const { navigateTo } = usePage()

  const {
    refetch: fetchUser,
    isLoading,
    isFetching,
    data: getUserData,
  } = useGetUser({ userId })

  useEffect(() => {
    window.scrollTo(0, 0)
    fetchUser()
  }, [])

  const isLoaderActive = isLoading || isFetching

  const categoryStat = getUserData?.data.count.answersStats.find(
    stat => stat.category === categoryId
  ) || {
    count: 0,
    correctCount: 0,
  }

  const { count, correctCount } = categoryStat

  const percentage = ((correctCount / count) * 100).toLocaleString('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })

  const text = `You answered ${correctCount} out of ${count} questions correctly. This is ${percentage}% of correctness.`

  const onHistoryBtnClick = useCallback(() => {
    setBrowseQuestionsPageState(state => ({
      ...state,
      filter: Filter.Answered,
      search: '',
      category: categoryId,
    }))
    navigateTo({ path: '/browse' })
  }, [])

  const onMoreStatsBtnClick = useCallback(() => {
    navigateTo({ path: '/best' })
  }, [])

  return (
    <AppLoader active={isLoaderActive}>
      <AppMessageBox
        headerNode={
          <AppHeader
            text={text}
            iconProps={{
              name: 'CHECK',
              size: 'xlarge',
              variant: 'success',
            }}
          />
        }
        buttonNode={
          <AppFlexContainer justifyContent="center" rowGap="7px" columnGap="7px">
            <AppFlexItem>
              <AppButton
                text="History"
                onClick={onHistoryBtnClick}
                variant="outlined"
                position="center"
              />
            </AppFlexItem>
            <AppFlexItem>
              <AppButton
                text="More stats"
                onClick={onMoreStatsBtnClick}
                variant="outlined"
                position="center"
              />
            </AppFlexItem>
          </AppFlexContainer>
        }
      />
    </AppLoader>
  )
}
